import { getData, postData, putData } from "./rest-api-helper";


export async function getDeptEmpListServ({ deptId, limit, pgNo }) {
    const details = {
        urlPath: "/departments/emp",
        queryParams: {
            ...(deptId && { deptId }),
            ...(limit && { limit }),
            ...(pgNo && { offset: (pgNo * limit) - limit }),
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function createDeptServ(data) {
    const details = {
        urlPath: "/departments",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function rmvEmpFromDept({ userId, deptId }) {
    const details = {
        urlPath: `/departments/rmvEmp`,
        body: {
            userId, deptId
        }
    }
    const res = await putData(details);
    return res;
}

export async function assignDeptEmp({ userId, deptId }) {
    const details = {
        urlPath: `/departments/assignEmp`,
        body: {
            userId, deptId
        }
    }
    const res = await putData(details);
    return res;
}

export async function editDeptServ({ deptName, deptId }) {
    const details = {
        urlPath: `/departments/editDept/${deptId}`,
        body: {
            deptName
        }
    }
    const res = await putData(details);
    return res;
}

export async function getDeptDDByProj({ projIdStrg }) {
    const details = {
        urlPath: "/departments/byProjDD",
        queryParams: {
            projIdStrg
        }
    }
    const res = await getData(details);
    return res.data;
}

export async function createDeptUserServ(data) {
    const details = {
        urlPath: "/departments/createUser",
        body: {
            ...data
        }
    }
    const res = await postData(details);
    return res;
}

export async function approveDeptServ(deptId) {
    const details = {
        urlPath: `/departments/approve/${deptId}`,
    }
    const res = await putData(details);
    return res;
}